import { z } from "zod"
import { withOptionalEmptyStringAsUndefined } from "@nano-portal/shared"
import { addressSchema, bankAccountSchema, countrySchema } from "@nano-portal/customers"

const addressSchemaCustom = addressSchema.extend({
  orientationNumber: withOptionalEmptyStringAsUndefined(addressSchema.shape.orientationNumber),
})

export type Address = z.infer<typeof addressSchemaCustom>

const addressWithCountrySchema = addressSchemaCustom.extend({
  countryCode: countrySchema,
})
export type AddressWithCountry = z.infer<typeof addressWithCountrySchema>

const bankAccountSchemaCustom = bankAccountSchema.extend({
  prefix: withOptionalEmptyStringAsUndefined(bankAccountSchema.shape.prefix),
})
export type BankAccount = z.infer<typeof bankAccountSchemaCustom>

export const MAX_FILE_SIZE_MB = 15
export const MAX_FILE_SIZE_B = 1024 * 1024 * MAX_FILE_SIZE_MB

export const productSchema = z.enum(["consumption", "production", "productionAndConsumption"])
export type Product = z.infer<typeof productSchema>

export const customerTypeSchema = z.enum(["household", "business"])
export type CustomerType = z.infer<typeof customerTypeSchema>
